import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ViewProjectPayDto } from 'src/app/web/interfaces/project/list/viewProjectPayDto';

@Component({
  selector: 'app-pay-popup-project',
  templateUrl: './pay-popup-project.component.html',
  styleUrls: ['./pay-popup-project.component.scss']
})
export class PayPopupProjectComponent implements OnInit {

  closeResult = '';
  item: ViewProjectPayDto

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, private modalService: NgbModal) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {

  }

  public open(itemEnd: ViewProjectPayDto, type: string) {
    this.item = itemEnd

    if(type == "group"){
      this.item = itemEnd
    }

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}

